import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "@/lib/content";

export const HeaderNav = () => (
  <header className="fixed inset-x-0 top-0 z-50 border-b border-[#E5E7EB]/70 bg-[#FAF9F5]/80 backdrop-blur-md">
    <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4">
      <a
        data-testid="nav-logo"
        href="#top"
        className="font-display text-xs font-bold tracking-[0.22em] text-[#131519] sm:text-sm"
      >
        METRO MOBILE DETAILS
      </a>
      <nav className="hidden items-center gap-8 text-sm font-medium text-[#4B5563] md:flex">
        <a data-testid="nav-services-link" href="#services" className="transition-colors hover:text-[#D97706]">
          Services
        </a>
        <a data-testid="nav-cashapp-link" href="#cashapp" className="transition-colors hover:text-[#D97706]">
          Cash App
        </a>
        <a data-testid="nav-book-button" href="#book" className="transition-colors hover:text-[#D97706]">
          Book Now
        </a>
      </nav>
      <div className="flex items-center gap-4">
        <a
          data-testid="nav-call-button"
          href={PHONE_TEL}
          className="flex items-center gap-2 rounded-full bg-[#131519] px-4 py-2 text-xs font-semibold text-white transition-colors hover:bg-[#D97706]"
        >
          <Phone size={13} />
          {PHONE_DISPLAY}
        </a>
        <Link
          data-testid="nav-owner-toggle"
          to="/owner"
          className="hidden text-xs font-medium text-[#9CA3AF] transition-colors hover:text-[#131519] sm:block"
        >
          Owner
        </Link>
      </div>
    </div>
  </header>
);
